module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<div><b>Выберите соответствия между полями и колонкам в файле</b></div>\n\n	<table class=\"gl-striped__table columns\">\n		<thead>\n		<tr>\n			<td>Индекс</td>\n			<td>Колонка</td>\n			<td>Поле</td>\n		</tr>\n		</thead>\n		<tbody>\n		")
    ;  for (var i = 0; i < data.columnsCount; i++) { 
    ; __append("\n		<tr>\n			<td><input type=\"checkbox\" name=\"index\" data-column=\"")
    ; __append(escapeFn( i ))
    ; __append("\" value=\"")
    ; __append(escapeFn( i ))
    ; __append("\"/></td>\n			<td>Колонка ")
    ; __append(escapeFn( i ))
    ; __append("</td>\n			<td>\n				<select name=\"field\" data-column=\"")
    ; __append(escapeFn( i ))
    ; __append("\">\n					<option value=\"\">не использовать</option>\n\n					")
    ;  Util.each(fields, function (title, name) { 
    ; __append("\n					<option value=\"")
    ; __append(escapeFn( name ))
    ; __append("\">")
    ; __append(escapeFn( title ))
    ; __append("</option>\n					")
    ;  }); 
    ; __append("\n				</select>\n			</td>\n		</tr>\n		")
    ;  } 
    ; __append("\n		</tbody>\n	</table>\n</div>\n\n<div class=\"row\">\n	<div><b>Строки из файла</b></div>\n	<div style=\"height: 260px;\">\n		<div name=\"grid\" class=\"h100\"></div>\n	</div>\n</div>\n\n<div class=\"row\">\n	<button on-click=\"onBackStepClick\" data-step=\"stepUpload\">Назад</button>\n	<button on-click=\"onMappingClick\" class=\"gl-primary-button\">Анализировать файл</button>\n</div>\n")
  }
  return __output.join("");

}